export const EstadoSolicitudAusencia=Object.freeze({
    PENDIENTE:"PENDIENTE",
    APROBADO:"APROBADO",
    RECHAZADO:"RECHAZADO"
})